import * as React from 'react';
import styles from './index.less';
import SidebarContainerStore from '@src/components/sidebar-container/store';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';

/**
 * 侧边栏容器
 * 常用于页面需要监听侧边栏的操作
 * @param store 侧边栏store, 控制参数控制显隐
 * @param className 可拓展className
 * @param effectType 侧边栏出场效果
 * @param children 专题页的侧边栏节点内容
 * @param rest 额外参数
 * @returns {JSX.Element}
 * @constructor
 */
const SidebarContainer = ({ store, className, effectType = 'fadeLeft', children, ...rest }) => {
  store.use();
  const sidebarEffectType = {
    fadeUp: styles.fadeUp,
    fadeRight: styles.fadeRight,
    fadeLeft: styles.fadeLeft,
    fadeDown: styles.fadeDown
  };

  return (
    <div className={cx(styles.sidebarContainer, store.isActive && styles.sidebarContainerAct, className, sidebarEffectType[effectType])} {...rest}>
      {children}
    </div>
  );
};

export default wrapStore(SidebarContainer, SidebarContainerStore);
